/* MONTAR image viewer: scoped watch imagery only; original photography is unchanged. */
(() => {
  'use strict';
  if (window.montarImageZoom) return;
  window.montarImageZoom = true;
  const selector = '.ranger-lp__model-img,.ranger-lp__function-media img,.ranger-lp__numbered-img,.mbg__image img,.mbx .photo img,.mf-card-image';
  let dialog, stage, photo, status, zoomLabel, trigger, savedY, oldBody, scale = 1, x = 0, y = 0, fitW = 1, fitH = 1, loaded = false, token = 0;
  const pointers = new Map();
  let gesture, moved = false, startPoint, lastTap = 0;
  const clamp = (n,a,b) => Math.max(a,Math.min(b,n));
  function draw() {
    const w=stage.clientWidth,h=stage.clientHeight;
    x=clamp(x,-Math.max(0,(fitW*scale-w)/2),Math.max(0,(fitW*scale-w)/2));
    y=clamp(y,-Math.max(0,(fitH*scale-h)/2),Math.max(0,(fitH*scale-h)/2));
    photo.style.width=fitW+'px'; photo.style.height=fitH+'px';
    photo.style.transform=`translate(${x}px,${y}px) scale(${scale})`;
    stage.classList.toggle('mz-zoomed',scale>1.01);
    zoomLabel.textContent=Math.round(scale*100)+'%';
    dialog.querySelector('[data-mz-out]').disabled=!loaded||scale<=1;
    dialog.querySelector('[data-mz-in]').disabled=!loaded||scale>=4;
  }
  function zoom(next,cx=stage.clientWidth/2,cy=stage.clientHeight/2) {
    if(!loaded)return;
    next=clamp(next,1,4);const ratio=next/scale;
    x=(cx-stage.clientWidth/2)*(1-ratio)+x*ratio;
    y=(cy-stage.clientHeight/2)*(1-ratio)+y*ratio; scale=next;draw();
  }
  function fit() {
    if(!loaded)return;
    const f=Math.min((stage.clientWidth-24)/photo.naturalWidth,(stage.clientHeight-24)/photo.naturalHeight,1);
    fitW=photo.naturalWidth*f;fitH=photo.naturalHeight*f;scale=1;x=y=0;draw();
  }
  function close() { if(dialog?.open)dialog.close(); }
  function create() {
    dialog=document.createElement('dialog');dialog.className='mz-dialog';dialog.setAttribute('aria-label','Watch image viewer');
    dialog.innerHTML='<div class="mz-bar"><span class="mz-title">MONTAR / CLOSER LOOK</span><button type="button" class="mz-close" data-mz-close aria-label="Close image viewer">CLOSE <span aria-hidden="true">×</span></button></div><div class="mz-stage"><img class="mz-photo" alt="" draggable="false"><p class="mz-status" role="status"></p></div><div class="mz-bottom"><span class="mz-help">Pinch or use + to zoom · Drag to explore</span><div class="mz-controls"><button type="button" data-mz-out aria-label="Zoom out">−</button><span class="mz-level" aria-live="polite">100%</span><button type="button" data-mz-in aria-label="Zoom in">+</button><button type="button" data-mz-reset>RESET</button></div></div>';
    document.body.append(dialog);stage=dialog.querySelector('.mz-stage');photo=dialog.querySelector('.mz-photo');status=dialog.querySelector('.mz-status');zoomLabel=dialog.querySelector('.mz-level');
    dialog.querySelector('[data-mz-close]').onclick=close;
    dialog.querySelector('[data-mz-in]').onclick=()=>zoom(scale+0.5);
    dialog.querySelector('[data-mz-out]').onclick=()=>zoom(scale-0.5);
    dialog.querySelector('[data-mz-reset]').onclick=fit;
    dialog.addEventListener('click',e=>{if(e.target===dialog)close()});
    dialog.addEventListener('close',()=>{
      token++;pointers.clear();photo.onload=photo.onerror=null;photo.removeAttribute('src');loaded=false;
      Object.assign(document.body.style,oldBody);window.scrollTo(0,savedY);
      if(trigger?.isConnected)trigger.focus({preventScroll:true});
    });
    dialog.addEventListener('keydown',e=>{
      if(e.key==='Escape'){e.preventDefault();close()}
      if((e.key==='+'||e.key==='=')&&!e.ctrlKey){e.preventDefault();zoom(scale+.5)}
      if(e.key==='-'){e.preventDefault();zoom(scale-.5)}
      if(e.key==='0'){e.preventDefault();fit()}
      if(scale>1&&['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(e.key)){e.preventDefault();const step=e.shiftKey?120:50;if(e.key==='ArrowLeft')x+=step;if(e.key==='ArrowRight')x-=step;if(e.key==='ArrowUp')y+=step;if(e.key==='ArrowDown')y-=step;draw();}
      if(e.key==='Tab'){
        const a=[...dialog.querySelectorAll('button:not([disabled])')];const i=a.indexOf(document.activeElement);
        if(e.shiftKey&&(i<=0)){e.preventDefault();a[a.length-1].focus()}
        else if(!e.shiftKey&&(i===a.length-1||i<0)){e.preventDefault();a[0].focus()}
      }
    });
    const beginGesture=()=>{const p=[...pointers.values()];gesture=p.length>1?{distance:Math.hypot(p[1].x-p[0].x,p[1].y-p[0].y),scale,x,y,cx:(p[0].x+p[1].x)/2,cy:(p[0].y+p[1].y)/2}:{px:p[0]?.x,py:p[0]?.y,x,y};};
    stage.addEventListener('pointerdown',e=>{
      if(e.button!==0)return;
      pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});stage.setPointerCapture(e.pointerId);
      if(pointers.size===1){moved=false;startPoint={x:e.clientX,y:e.clientY,target:e.target};}else moved=true;
      beginGesture();
    });
    stage.addEventListener('pointermove',e=>{
      if(!pointers.has(e.pointerId)||!loaded)return;
      pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});const p=[...pointers.values()];
      if(Math.hypot(e.clientX-startPoint.x,e.clientY-startPoint.y)>6)moved=true;
      if(p.length>1){
        const next=clamp(gesture.scale*Math.hypot(p[1].x-p[0].x,p[1].y-p[0].y)/Math.max(1,gesture.distance),1,4),r=next/gesture.scale,rect=stage.getBoundingClientRect();
        const cx=(p[0].x+p[1].x)/2,cy=(p[0].y+p[1].y)/2;
        x=gesture.x*r+(gesture.cx-rect.left-stage.clientWidth/2)*(1-r)+cx-gesture.cx;
        y=gesture.y*r+(gesture.cy-rect.top-stage.clientHeight/2)*(1-r)+cy-gesture.cy;scale=next;draw();
      }else if(scale>1){x=gesture.x+e.clientX-gesture.px;y=gesture.y+e.clientY-gesture.py;draw();}
    });
    const end=e=>{
      if(!pointers.has(e.pointerId))return;
      pointers.delete(e.pointerId);
      if(e.type==='pointercancel'){moved=true;}
      if(pointers.size){beginGesture();return;}
      if(!moved&&e.type==='pointerup'){
        if(startPoint.target===stage){close();return;}
        const now=Date.now();
        if(e.pointerType==='mouse'||now-lastTap<320){const r=stage.getBoundingClientRect();zoom(scale>1?1:2,e.clientX-r.left,e.clientY-r.top);lastTap=0;}else lastTap=now;
      }
    };
    stage.addEventListener('pointerup',end);stage.addEventListener('pointercancel',end);
    window.addEventListener('resize',()=>{if(dialog.open)fit()});
  }
  function original(src){try{const u=new URL(src,location.href);if(/(^|\.)shopify\.com$|(^|\.)praesidus\.com$/.test(u.hostname)){['width','height','crop'].forEach(k=>u.searchParams.delete(k));}return u.href;}catch{return src}}
  function open(img,launcher=img) {
    if(!dialog)create();if(dialog.open)return;
    const src=img.currentSrc||img.src||img.dataset.rangerSrc;if(!src)return;
    trigger=launcher;scale=1;x=y=0;loaded=false;lastTap=0;const id=++token;
    photo.style.visibility='hidden';photo.alt=img.alt||'MONTAR watch detail';status.hidden=false;status.textContent='Loading image…';
    savedY=window.scrollY;oldBody={position:document.body.style.position,top:document.body.style.top,width:document.body.style.width,overflow:document.body.style.overflow};
    Object.assign(document.body.style,{position:'fixed',top:-savedY+'px',width:'100%',overflow:'hidden'});
    dialog.showModal();draw();dialog.querySelector('[data-mz-close]').focus();
    photo.onload=()=>{if(id!==token)return;loaded=true;status.hidden=true;photo.style.visibility='visible';fit()};
    let fallback=false;photo.onerror=()=>{if(id!==token)return;if(!fallback&&photo.src!==src){fallback=true;photo.src=src;return;}status.hidden=false;status.textContent='This image could not load. Close and try again.';};
    photo.src=original(src);
  }
  function setup(root=document){root.querySelectorAll(selector).forEach(img=>{
    if(img.dataset.mzReady||img.closest('a,button'))return;img.dataset.mzReady='true';img.classList.add('mz-trigger');img.tabIndex=0;img.setAttribute('role','button');img.setAttribute('aria-haspopup','dialog');img.setAttribute('aria-label','Enlarge image: '+(img.alt||'MONTAR watch'));img.title='Tap to zoom';
    img.addEventListener('click',()=>open(img));img.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();open(img)}});
    /* Affordance is separate from variant and feature controls. */
    let host=img.closest('.ranger-lp__model-shot,.ranger-lp__function-media,.ranger-lp__numbered-media,.mbg__image,.mbx .photo');
    if(img.matches('.mf-card-image')){host=document.createElement('div');host.className='mz-film-wrap';img.before(host);host.append(img);}
    if(host&&!host.querySelector('.mz-hint')){host.classList.add('mz-host');const b=document.createElement('button');b.type='button';b.className='mz-hint';b.textContent='＋ ZOOM';b.setAttribute('aria-label','Enlarge watch image');b.onclick=()=>{const current=[...host.querySelectorAll(selector)].find(i=>getComputedStyle(i).visibility!=='hidden'&&!i.closest('[hidden]'));if(current)open(current,b)};host.append(b);}
  });}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup());else setup();
  document.addEventListener('shopify:section:load',e=>setup(e.target));
})();
